import styles from './NumbersBox.module.scss';

function NumbersBox({ children }: { children?: any }) {
  return <div className={styles.root}>{children}</div>;
}

export default NumbersBox;
